import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";

import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";

import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { CoreModule } from "@tylertech/core-module";
import { InfoTableModule } from "@tylertech/info-table-module";
import { AdvancedComponentsModule } from "@tylertech/advanced-components-module";
import { AttachmentsModule } from "@tylertech/attachments-module";
import { MetadataModule } from "@tylertech/metadata-module";
import { DataLoadModule } from "@tylertech/data-load-module";
import { IntentsModule } from "@tylertech/intents-module";

import
{
    CardAvatarComponent,
    DetailTableComponent,
    EditDialogComponent,
    InfoCardCollectionComponent,
    InfoCardComponent,
    InfoCardDetailFieldComponent,
    InfoCardEditComponent,
    InfoCardSearchDialogComponent,
    InfoCardViewComponent,
} from "./components";
import { InfoCardDialogService, InfoCardService, InfoCardSearchService } from "./services";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
];

const angularMaterialModules = [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
];

const lgdModules = [
    CommandsModule,
    CoreModule,
    CommonComponentsModule,
    CustomViewModule,
    AttachmentsModule,
    InfoTableModule,
    MetadataModule,
    AdvancedComponentsModule,
    IntentsModule,
    DataLoadModule
];

const exportedComponents = [
    InfoCardCollectionComponent,
    InfoCardComponent,
    InfoCardViewComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: [
        ...exportedComponents,
        CardAvatarComponent,
        DetailTableComponent,
        EditDialogComponent,
        InfoCardDetailFieldComponent,
        InfoCardEditComponent,
        InfoCardSearchDialogComponent,
    ],
    exports: exportedComponents,
    providers: [
        InfoCardDialogService,
        InfoCardSearchService,
        InfoCardService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InfoCardModule { }
